"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const modelsProxy = require("../models/carrier-accounts/carrier-account-models.v0");
exports.models = modelsProxy;
const shared_1 = require("./shared");
exports.createCarrierAccount = async (authorization, correlationId, carrierAccount) => {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/carrierAccounts`, carrierAccount, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.location.split('/').pop();
};
exports.getCarrierAccount = async (authorization, correlationId, carrierAccountId) => {
    try {
        return (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/carrierAccounts/${carrierAccountId}`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
    }
    catch (e) {
        if (e.response.status === 404) {
            return undefined;
        }
        throw e;
    }
};
exports.getCarrierAccounts = async (authorization, correlationId) => {
    const getAll = async (paginationUrl) => {
        const url = paginationUrl || `${shared_1.getBaseUrl()}/v0/carrierAccounts`;
        const apiResponse = (await axios_1.default.get(url, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
        const carrierAccounts = apiResponse.items;
        if (apiResponse._links && apiResponse._links.next) {
            carrierAccounts.push(...(await getAll(apiResponse._links.next.href)));
        }
        return carrierAccounts;
    };
    return getAll();
};
exports.updateCarrierAccount = async (authorization, correlationId, id, etag, patch) => {
    const headers = Object.assign(Object.assign({}, shared_1.getHeaders(authorization, correlationId)), { 'if-match': etag });
    const response = await axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/carrierAccounts/${id}`, patch, {
        headers,
    });
    return response.headers.etag;
};
exports.deleteCarrierAccount = async (authorization, correlationId, id) => {
    const response = await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/carrierAccounts/${id}`, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.etag;
};
//# sourceMappingURL=carrier-accounts.v0.js.map